import MggpPluginInteractive from './mggp-plugin-interactive';

MggpPluginInteractive.prototype.name = process.env.NAME;
MggpPluginInteractive.prototype.version = process.env.VERSION;
MggpPluginInteractive.prototype.build = process.env.BUILD;

export default MggpPluginInteractive;
